/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_CtaInputs */

const en_mk_sec_cta = /** @type {(inputs: Mk_Sec_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security & data page`)
};

const id_mk_sec_cta = /** @type {(inputs: Mk_Sec_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman keamanan & data`)
};

/**
* | output |
* | --- |
* | "Security & data page" |
*
* @param {Mk_Sec_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_cta = /** @type {((inputs?: Mk_Sec_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_cta(inputs)
	return en_mk_sec_cta(inputs)
});